[
  {
    "coverageBasis": "method-path-presence",
    "family": "Data Channels",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/data_channels.yaml",
    "expectedOperations": 3,
    "implementedOperations": 3,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/branches",
        "summary": "List physical branches",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.holder.data-channels",
        "scalarPath": "/reference/insurance#tag/insuranceholderdata-channels/get/open-insurance/channels/v2/branches"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/electronic-channels",
        "summary": "List electronic channels",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.holder.data-channels",
        "scalarPath": "/reference/insurance#tag/insuranceholderdata-channels/get/open-insurance/channels/v2/electronic-channels"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/phone-channels",
        "summary": "List phone channels",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.holder.data-channels",
        "scalarPath": "/reference/insurance#tag/insuranceholderdata-channels/get/open-insurance/channels/v2/phone-channels"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Consents",
    "phase": "2",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/753728",
    "expectedOperations": 3,
    "implementedOperations": 3,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/consents/v3/consents",
        "summary": "Create consent",
        "requiredScopes": ["consents"],
        "status": "implemented",
        "implementedTag": "insurance.holder.consents",
        "scalarPath": "/reference/insurance#tag/insuranceholderconsents/post/open-insurance/consents/v3/consents"
      },
      {
        "method": "get",
        "path": "/open-insurance/consents/v3/consents/{consentId}",
        "summary": "Read consent",
        "requiredScopes": ["consents"],
        "status": "implemented",
        "implementedTag": "insurance.holder.consents",
        "scalarPath": "/reference/insurance#tag/insuranceholderconsents/get/open-insurance/consents/v3/consents/{consentId}"
      },
      {
        "method": "delete",
        "path": "/open-insurance/consents/v3/consents/{consentId}",
        "summary": "Revoke consent",
        "requiredScopes": ["consents"],
        "status": "implemented",
        "implementedTag": "insurance.holder.consents",
        "scalarPath": "/reference/insurance#tag/insuranceholderconsents/delete/open-insurance/consents/v3/consents/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Resources",
    "phase": "2",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/3998176",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/resources/v3/resources",
        "summary": "List consented resources",
        "requiredScopes": ["resources"],
        "status": "implemented",
        "implementedTag": "insurance.holder.resources",
        "scalarPath": "/reference/insurance#tag/insuranceholderresources/get/open-insurance/resources/v3/resources"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Customers",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4259841",
    "expectedOperations": 6,
    "implementedOperations": 6,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/personal/identifications",
        "summary": "List personal IDs",
        "requiredScopes": ["customers"],
        "status": "implemented",
        "implementedTag": "insurance.holder.customers",
        "scalarPath": "/reference/insurance#tag/insuranceholdercustomers/get/open-insurance/customers/v2/personal/identifications"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/personal/qualifications",
        "summary": "List personal profiles",
        "requiredScopes": ["customers"],
        "status": "implemented",
        "implementedTag": "insurance.holder.customers",
        "scalarPath": "/reference/insurance#tag/insuranceholdercustomers/get/open-insurance/customers/v2/personal/qualifications"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/personal/complimentary-information",
        "summary": "List personal complimentary information",
        "requiredScopes": ["customers"],
        "status": "implemented",
        "implementedTag": "insurance.holder.customers",
        "scalarPath": "/reference/insurance#tag/insuranceholdercustomers/get/open-insurance/customers/v2/personal/complimentary-information"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/business/identifications",
        "summary": "List business IDs",
        "requiredScopes": ["customers"],
        "status": "implemented",
        "implementedTag": "insurance.holder.customers",
        "scalarPath": "/reference/insurance#tag/insuranceholdercustomers/get/open-insurance/customers/v2/business/identifications"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/business/qualifications",
        "summary": "List business profiles",
        "requiredScopes": ["customers"],
        "status": "implemented",
        "implementedTag": "insurance.holder.customers",
        "scalarPath": "/reference/insurance#tag/insuranceholdercustomers/get/open-insurance/customers/v2/business/qualifications"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/business/complimentary-information",
        "summary": "List business complimentary information",
        "requiredScopes": ["customers"],
        "status": "implemented",
        "implementedTag": "insurance.holder.customers",
        "scalarPath": "/reference/insurance#tag/insuranceholdercustomers/get/open-insurance/customers/v2/business/complimentary-information"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Auto",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/623542273",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto",
        "summary": "List insurance-auto",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.auto",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsauto/get/open-insurance/insurance-auto/v2/insurance-auto"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.auto",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsauto/get/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.auto",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsauto/get/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.auto",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsauto/get/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Patrimonial",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/main/documentation/source/files/swagger/current/insurance-patrimonial.yaml",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial",
        "summary": "List insurance-patrimonial",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.patrimonial",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspatrimonial/get/open-insurance/insurance-patrimonial/v2/insurance-patrimonial"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.patrimonial",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspatrimonial/get/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.patrimonial",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspatrimonial/get/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.patrimonial",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspatrimonial/get/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Person",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4195038",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person",
        "summary": "List insurance-person",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.person",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsperson/get/open-insurance/insurance-person/v2/insurance-person"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.person",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsperson/get/open-insurance/insurance-person/v2/insurance-person/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.person",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsperson/get/open-insurance/insurance-person/v2/insurance-person/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.person",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsperson/get/open-insurance/insurance-person/v2/insurance-person/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Housing",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4260049",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing",
        "summary": "List insurance-housing",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.housing",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductshousing/get/open-insurance/insurance-housing/v2/insurance-housing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.housing",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductshousing/get/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.housing",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductshousing/get/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.housing",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductshousing/get/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Financial Risk",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/624099381",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk",
        "summary": "List insurance-financial-risk",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-risk",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-risk/get/open-insurance/insurance-financial-risk/v2/insurance-financial-risk"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-risk",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-risk/get/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-risk",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-risk/get/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-risk",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-risk/get/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Responsibility",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/623476778",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility",
        "summary": "List insurance-responsibility",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.responsibility",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsresponsibility/get/open-insurance/insurance-responsibility/v2/insurance-responsibility"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.responsibility",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsresponsibility/get/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.responsibility",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsresponsibility/get/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.responsibility",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsresponsibility/get/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Rural",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4194821",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural",
        "summary": "List insurance-rural",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.rural",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsrural/get/open-insurance/insurance-rural/v2/insurance-rural"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.rural",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsrural/get/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.rural",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsrural/get/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.rural",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsrural/get/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Transport",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4260144",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport",
        "summary": "List insurance-transport",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.transport",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductstransport/get/open-insurance/insurance-transport/v2/insurance-transport"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.transport",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductstransport/get/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.transport",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductstransport/get/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.transport",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductstransport/get/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Acceptance And Branches Abroad",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/623476737",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad",
        "summary": "List insurance-acceptance-and-branches-abroad",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.acceptance-and-branches-abroad",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsacceptance-and-branches-abroad/get/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_POLICYINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.acceptance-and-branches-abroad",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsacceptance-and-branches-abroad/get/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/policy-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_PREMIUM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.acceptance-and-branches-abroad",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsacceptance-and-branches-abroad/get/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/premium"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.acceptance-and-branches-abroad",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsacceptance-and-branches-abroad/get/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Financial Assistance",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4129464",
    "expectedOperations": 3,
    "implementedOperations": 3,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/contracts",
        "summary": "List contracts",
        "requiredScopes": ["FINANCIAL_ASSISTANCE_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-assistance",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-assistance/get/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/contracts"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/contract-info",
        "summary": "Read contract info",
        "requiredScopes": ["FINANCIAL_ASSISTANCE_CONTRACTINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-assistance",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-assistance/get/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/contract-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/movements",
        "summary": "Read movements",
        "requiredScopes": ["FINANCIAL_ASSISTANCE_MOVEMENTS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.financial-assistance",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductsfinancial-assistance/get/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/movements"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Capitalization Title",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4194853",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/plans",
        "summary": "List plans",
        "requiredScopes": ["CAPITALIZATION_TITLE_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.capitalization-title",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductscapitalization-title/get/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/plans"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/plan-info",
        "summary": "Read plan info",
        "requiredScopes": ["CAPITALIZATION_TITLE_PLANINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.capitalization-title",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductscapitalization-title/get/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/plan-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/events",
        "summary": "Read events",
        "requiredScopes": ["CAPITALIZATION_TITLE_EVENTS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.capitalization-title",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductscapitalization-title/get/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/events"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/settlements",
        "summary": "Read settlements",
        "requiredScopes": ["CAPITALIZATION_TITLE_SETTLEMENTS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.capitalization-title",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductscapitalization-title/get/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/settlements"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Pension Plan",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4195028",
    "expectedOperations": 6,
    "implementedOperations": 6,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/contracts",
        "summary": "List contracts",
        "requiredScopes": ["PENSION_PLAN_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspension-plan/get/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/contracts"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/contract-info",
        "summary": "Read contract info",
        "requiredScopes": ["PENSION_PLAN_CONTRACTINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspension-plan/get/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/contract-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/movements",
        "summary": "Read movements",
        "requiredScopes": ["PENSION_PLAN_MOVEMENTS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspension-plan/get/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/movements"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/portabilities",
        "summary": "Read portabilities",
        "requiredScopes": ["PENSION_PLAN_PORTABILITIES_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspension-plan/get/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/portabilities"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/withdrawals",
        "summary": "Read withdrawals",
        "requiredScopes": ["PENSION_PLAN_WITHDRAWALS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspension-plan/get/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/withdrawals"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/claim",
        "summary": "Read claims",
        "requiredScopes": ["PENSION_PLAN_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductspension-plan/get/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Life Pension",
    "phase": "2",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/4194960",
    "expectedOperations": 6,
    "implementedOperations": 6,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/contracts",
        "summary": "List insurance-life-pension",
        "requiredScopes": ["LIFE_PENSION_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductslife-pension/get/open-insurance/insurance-life-pension/v2/insurance-life-pension/contracts"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/contract-info",
        "summary": "Read contract info",
        "requiredScopes": ["LIFE_PENSION_CONTRACTINFO_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductslife-pension/get/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/contract-info"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/movements",
        "summary": "Read movements",
        "requiredScopes": ["LIFE_PENSION_MOVEMENTS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductslife-pension/get/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/movements"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/portabilities",
        "summary": "Read portabilities",
        "requiredScopes": ["LIFE_PENSION_PORTABILITIES_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductslife-pension/get/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/portabilities"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/withdrawals",
        "summary": "Read withdrawals",
        "requiredScopes": ["LIFE_PENSION_WITHDRAWALS_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductslife-pension/get/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/withdrawals"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/claim",
        "summary": "Read claims",
        "requiredScopes": ["LIFE_PENSION_CLAIM_READ"],
        "status": "implemented",
        "implementedTag": "insurance.holder.products.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceholderproductslife-pension/get/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/claim"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Claim Notification",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/main/documentation/source/files/swagger/current/claim-notification.yaml",
    "expectedOperations": 2,
    "implementedOperations": 2,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/claim-notification/v2/request/damage/{consentId}",
        "summary": "Submit damage claim notification",
        "requiredScopes": ["CLAIM_NOTIFICATION_REQUEST_DAMAGE_CREATE"],
        "status": "implemented",
        "implementedTag": "insurance.holder.commands",
        "scalarPath": "/reference/insurance#tag/insuranceholdercommands/post/open-insurance/claim-notification/v2/request/damage/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/claim-notification/v2/request/person/{consentId}",
        "summary": "Submit person claim notification",
        "requiredScopes": ["CLAIM_NOTIFICATION_REQUEST_PERSON_CREATE"],
        "status": "implemented",
        "implementedTag": "insurance.holder.commands",
        "scalarPath": "/reference/insurance#tag/insuranceholdercommands/post/open-insurance/claim-notification/v2/request/person/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Auto",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-auto.yaml",
    "expectedOperations": 5,
    "implementedOperations": 5,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-auto/v2/lead/request",
        "summary": "Envia dados de cotação e contratação de AutoLead",
        "requiredScopes": ["quote-auto-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-auto/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-auto/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de AutoLead identificado por consentId",
        "requiredScopes": ["quote-auto-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-auto/v2/lead/request/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-auto/v2/request",
        "summary": "Envia dados de cotação e contratação de Auto",
        "requiredScopes": ["quote-auto"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-auto/v2/request"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-auto/v2/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e contratação de Auto identificado por consentId",
        "requiredScopes": ["quote-auto"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/get/open-insurance/quote-auto/v2/request/{consentId}/quote-status"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-auto/v2/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de Auto identificado por consentId",
        "requiredScopes": ["quote-auto"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-auto/v2/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Housing",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-housing.yaml",
    "expectedOperations": 2,
    "implementedOperations": 2,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-housing/v2/lead/request",
        "summary": "Envia dados de solicitação de cotação de HousingLead",
        "requiredScopes": ["quote-housing-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-housing/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-housing/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de solicitação de cotação de HousingLead identificado por consentId",
        "requiredScopes": ["quote-housing-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-housing/v2/lead/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Rural",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-rural.yaml",
    "expectedOperations": 2,
    "implementedOperations": 2,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-rural/v2/lead/request",
        "summary": "Envia dados de cotação de RuralLead",
        "requiredScopes": ["quote-rural-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-rural/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-rural/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação de RuralLead identificado por consentId",
        "requiredScopes": ["quote-rural-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-rural/v2/lead/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Transport",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-transport.yaml",
    "expectedOperations": 2,
    "implementedOperations": 2,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-transport/v2/lead/request",
        "summary": "Envia dados de cotação de TransportLead",
        "requiredScopes": ["quote-transport-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-transport/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-transport/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação de TransportLead identificado por consentId",
        "requiredScopes": ["quote-transport-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-transport/v2/lead/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Person",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-person.yaml",
    "expectedOperations": 8,
    "implementedOperations": 8,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-person/v2/lead/request",
        "summary": "Envia dados de cotação e contratação de PersonLead",
        "requiredScopes": ["openid", "quote-person-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-person/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-person/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de PersonLead identificado por consentId",
        "requiredScopes": ["openid", "quote-person-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-person/v2/lead/request/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-person/v2/life/request",
        "summary": "Envia dados de cotação e contratação de PersonLife",
        "requiredScopes": ["openid", "quote-person-life"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-person/v2/life/request"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-person/v2/life/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e contratação de PersonLife identificado por consentId",
        "requiredScopes": ["openid", "quote-person-life"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/get/open-insurance/quote-person/v2/life/request/{consentId}/quote-status"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-person/v2/life/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de PersonLife identificado por consentId",
        "requiredScopes": ["openid", "quote-person-life"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-person/v2/life/request/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-person/v2/travel/request",
        "summary": "Envia dados de cotação e contratação de PersonTravel",
        "requiredScopes": ["openid", "quote-person-travel"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-person/v2/travel/request"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-person/v2/travel/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e contratação de PersonTravel identificado por consentId",
        "requiredScopes": ["openid", "quote-person-travel"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/get/open-insurance/quote-person/v2/travel/request/{consentId}/quote-status"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-person/v2/travel/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de PersonTravel identificado por consentId",
        "requiredScopes": ["openid", "quote-person-travel"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-person/v2/travel/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Capitalization Title",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-capitalization-title.yaml",
    "expectedOperations": 6,
    "implementedOperations": 6,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-capitalization-title/v2/lead/request",
        "summary": "Envia dados de cotação e compra de CapitalizationTitleLead",
        "requiredScopes": ["openid", "quote-capitalization-title-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-capitalization-title/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-capitalization-title/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação e compra de CapitalizationTitleLead identificado por consentId",
        "requiredScopes": ["openid", "quote-capitalization-title-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-capitalization-title/v2/lead/request/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-capitalization-title/v2/request",
        "summary": "Envia dados de cotação e compra de CapitalizationTitle",
        "requiredScopes": ["openid", "quote-capitalization-title"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-capitalization-title/v2/request"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-capitalization-title/v2/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e compra de CapitalizationTitle identificado por consentId",
        "requiredScopes": ["openid", "quote-capitalization-title"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/get/open-insurance/quote-capitalization-title/v2/request/{consentId}/quote-status"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-capitalization-title/v2/request/{consentId}",
        "summary": "Atualiza dados de cotação e compra de CapitalizationTitle identificado por consentId",
        "requiredScopes": ["openid", "quote-capitalization-title"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/quote-capitalization-title/v2/request/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-capitalization-title/v2/raffle/request",
        "summary": "Enviar os dados de solicitação de Pagamento de Sorteio de Título de Capitalização",
        "requiredScopes": ["openid", "quote-capitalization-title-raffle"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/quote-capitalization-title/v2/raffle/request"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Contract Life Pension",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-life-pension.yaml",
    "expectedOperations": 5,
    "implementedOperations": 5,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/contract-life-pension/v2/lead/request",
        "summary": "Envia dados de solicitação de contratação de LifePensionLead",
        "requiredScopes": ["openid", "contract-life-pension-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/contract-life-pension/v2/lead/request"
      },
      {
        "method": "patch",
        "path": "/open-insurance/contract-life-pension/v2/lead/request/{consentId}",
        "summary": "Atualiza dados solicitação de de contratação de LifePensionLead identificado por consentId",
        "requiredScopes": ["openid", "contract-life-pension-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/contract-life-pension/v2/lead/request/{consentId}"
      },
      {
        "method": "post",
        "path": "/open-insurance/contract-life-pension/v2/request",
        "summary": "Envia dados de solicitação de Contratação e Portabilidade Firme Previdência Sobrevivência",
        "requiredScopes": ["openid", "contract-life-pension"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/post/open-insurance/contract-life-pension/v2/request"
      },
      {
        "method": "get",
        "path": "/open-insurance/contract-life-pension/v2/request/{consentId}/quote-status",
        "summary": "Obtém os dados de Contratação e Portabilidade Firme Previdência Sobrevivência identificado por consentId",
        "requiredScopes": ["openid", "contract-life-pension"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/get/open-insurance/contract-life-pension/v2/request/{consentId}/quote-status"
      },
      {
        "method": "patch",
        "path": "/open-insurance/contract-life-pension/v2/request/{consentId}",
        "summary": "Atualiza dados de Contratação e Portabilidade Firme Previdência Sobrevivência identificado por consentId",
        "requiredScopes": ["openid", "contract-life-pension"],
        "status": "implemented",
        "implementedTag": "insurance.current.quotes",
        "scalarPath": "/reference/insurance#tag/insurancecurrentquotes/patch/open-insurance/contract-life-pension/v2/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Withdrawal",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/quote-life-pension-withdrawal.yaml",
    "expectedOperations": 3,
    "implementedOperations": 3,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/withdrawal/v2/lead/request",
        "summary": "Envia dados de solicitação de Resgate de Previdência Lead",
        "requiredScopes": ["openid", "withdrawal-pension-lead"],
        "status": "implemented",
        "implementedTag": "insurance.current.processing",
        "scalarPath": "/reference/insurance#tag/insurancecurrentprocessing/post/open-insurance/withdrawal/v2/lead/request"
      },
      {
        "method": "post",
        "path": "/open-insurance/withdrawal/v2/pension/request",
        "summary": "Enviar os dados de solicitação de Resgate de Previdência",
        "requiredScopes": ["openid", "withdrawal-pension"],
        "status": "implemented",
        "implementedTag": "insurance.current.processing",
        "scalarPath": "/reference/insurance#tag/insurancecurrentprocessing/post/open-insurance/withdrawal/v2/pension/request"
      },
      {
        "method": "post",
        "path": "/open-insurance/withdrawal/v2/capitalization-title/request",
        "summary": "Enviar os dados de solicitação de Resgate de Título de Capitalização",
        "requiredScopes": ["openid", "withdrawal-capitalization-title"],
        "status": "implemented",
        "implementedTag": "insurance.current.processing",
        "scalarPath": "/reference/insurance#tag/insurancecurrentprocessing/post/open-insurance/withdrawal/v2/capitalization-title/request"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Dynamic Fields",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/dynamic-fields.yaml",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/dynamic-fields/v2/damage-and-person",
        "summary": "Obtém a lista de Campos dinâmicos de Danos e Pessoas.",
        "requiredScopes": ["dynamic-fields"],
        "status": "implemented",
        "implementedTag": "insurance.current.dynamic-fields",
        "scalarPath": "/reference/insurance#tag/insurancecurrentdynamic-fields/get/open-insurance/dynamic-fields/v2/damage-and-person"
      },
      {
        "method": "get",
        "path": "/open-insurance/dynamic-fields/v2/capitalization-title",
        "summary": "Obtém a lista de Campos dinâmicos de Títulos de Capitalização.",
        "requiredScopes": ["dynamic-fields"],
        "status": "implemented",
        "implementedTag": "insurance.current.dynamic-fields",
        "scalarPath": "/reference/insurance#tag/insurancecurrentdynamic-fields/get/open-insurance/dynamic-fields/v2/capitalization-title"
      },
      {
        "method": "post",
        "path": "/open-insurance/dynamic-fields/v2/callback/damage-and-person",
        "summary": "Informa via callback a consulta e a atualização dos campos dinâmicos.",
        "requiredScopes": ["dynamic-fields"],
        "status": "implemented",
        "implementedTag": "insurance.current.dynamic-fields",
        "scalarPath": "/reference/insurance#tag/insurancecurrentdynamic-fields/post/open-insurance/dynamic-fields/v2/callback/damage-and-person"
      },
      {
        "method": "post",
        "path": "/open-insurance/dynamic-fields/v2/callback/capitalization-title",
        "summary": "Informa via callback a consulta e a atualização dos campos dinâmicos.",
        "requiredScopes": ["dynamic-fields"],
        "status": "implemented",
        "implementedTag": "insurance.current.dynamic-fields",
        "scalarPath": "/reference/insurance#tag/insurancecurrentdynamic-fields/post/open-insurance/dynamic-fields/v2/callback/capitalization-title"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Webhook",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/23bc730b2a0d5fcb65bff3513218a293f016e8a9/documentation/source/files/swagger/webhook.yaml",
    "expectedOperations": 4,
    "implementedOperations": 4,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/quote/{versionApi}/request/{consentId}/quote-status",
        "summary": "Notificação de mudança no estado da cotação referente as APIs de Contratação (Danos, Previdência, Pessoas e Capitalização)",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.current.webhooks",
        "scalarPath": "/reference/insurance#tag/insurancecurrentwebhooks/post/open-insurance/webhook/v2/quote/{versionApi}/request/{consentId}/quote-status"
      },
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/products-services/{authorisationServerId}/{versionApi}/capitalization-title",
        "summary": "Notificações de mudanças de payload referente a API de Produtos de Título de Capitalização.",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.current.webhooks",
        "scalarPath": "/reference/insurance#tag/insurancecurrentwebhooks/post/open-insurance/webhook/v2/products-services/{authorisationServerId}/{versionApi}/capitalization-title"
      },
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/damage-and-person",
        "summary": "Notificações de mudanças no payload da API de Campos Dinâmicos.",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.current.webhooks",
        "scalarPath": "/reference/insurance#tag/insurancecurrentwebhooks/post/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/damage-and-person"
      },
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/capitalization-title",
        "summary": "Notificações de mudanças no payload da API de Campos Dinâmicos.",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.current.webhooks",
        "scalarPath": "/reference/insurance#tag/insurancecurrentwebhooks/post/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/capitalization-title"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Data Channels (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/data_channels.yaml",
    "expectedOperations": 3,
    "implementedOperations": 0,
    "missingOperations": 3,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/branches",
        "summary": "List physical branches",
        "requiredScopes": [],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/electronic-channels",
        "summary": "List electronic channels",
        "requiredScopes": [],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/phone-channels",
        "summary": "List phone channels",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Intermediary",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/intermediary.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/intermediary/{countrySubDivision}",
        "summary": "List intermediaries for an UF",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.intermediary",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataintermediary/get/open-insurance/channels/v2/intermediary/{countrySubDivision}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Intermediary (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/intermediary.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/intermediary/{countrySubDivision}",
        "summary": "List intermediaries for an UF",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Referenced Network",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/referenced-network.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/referenced-network/{countrySubDivision}/{serviceType}",
        "summary": "List referenced network partners by service type",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.referenced-network",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datareferenced-network/get/open-insurance/channels/v2/referenced-network/{countrySubDivision}/{serviceType}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Referenced Network (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/referenced-network.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/referenced-network/{countrySubDivision}/{serviceType}",
        "summary": "List referenced network partners by service type",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Assistance General Assets",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/assistance-general-assets.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/assistance-general-assets",
        "summary": "List assistance-general-assets open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.assistance-general-assets",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataassistance-general-assets/get/open-insurance/products-services/v2/assistance-general-assets"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Assistance General Assets (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/assistance-general-assets.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/assistance-general-assets",
        "summary": "List assistance-general-assets open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Auto Extended Warranty",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/auto-extended-warranty.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/auto-extended-warranty",
        "summary": "List auto-extended-warranty open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.auto-extended-warranty",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataauto-extended-warranty/get/open-insurance/products-services/v2/auto-extended-warranty"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Auto Extended Warranty (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/auto-extended-warranty.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/auto-extended-warranty",
        "summary": "List auto-extended-warranty open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Auto Insurance",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/auto-insurance.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}",
        "summary": "List auto-insurance products for a vehicle",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.auto-insurance",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataauto-insurance/get/open-insurance/products-services/v2/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Auto Insurance (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/auto-insurance.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}",
        "summary": "List auto-insurance products for a vehicle",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Business",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/business.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/business",
        "summary": "List business open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.business",
        "scalarPath": "/reference/insurance#tag/insuranceopen-databusiness/get/open-insurance/products-services/v2/business"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Business (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/business.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/business",
        "summary": "List business open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Capitalization Title",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/capitalization-title.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/capitalization-title",
        "summary": "List capitalization-title open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.capitalization-title",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datacapitalization-title/get/open-insurance/products-services/v2/capitalization-title"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Capitalization Title (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/capitalization-title.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/capitalization-title",
        "summary": "List capitalization-title open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Condominium",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/condominium.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/condominium/{commercializationArea}",
        "summary": "List condominium products by commercialization area",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.condominium",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datacondominium/get/open-insurance/products-services/v2/condominium/{commercializationArea}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Condominium (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/condominium.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/condominium/{commercializationArea}",
        "summary": "List condominium products by commercialization area",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Cyber Risk",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/cyber-risk.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/cyber-risk",
        "summary": "List cyber-risk open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.cyber-risk",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datacyber-risk/get/open-insurance/products-services/v2/cyber-risk"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Cyber Risk (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/cyber-risk.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/cyber-risk",
        "summary": "List cyber-risk open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Directors & Officers Liability",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/directors-officers-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/directors-officers-liability",
        "summary": "List directors-officers-liability open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.directors-officers-liability",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datadirectors-officers-liability/get/open-insurance/products-services/v2/directors-officers-liability"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Directors & Officers Liability (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/directors-officers-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/directors-officers-liability",
        "summary": "List directors-officers-liability open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Domestic Credit",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/domestic-credit.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/domestic-credit",
        "summary": "List domestic-credit open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.domestic-credit",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datadomestic-credit/get/open-insurance/products-services/v2/domestic-credit"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Domestic Credit (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/domestic-credit.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/domestic-credit",
        "summary": "List domestic-credit open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Engineering",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/engineering.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/engineering",
        "summary": "List engineering open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.engineering",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataengineering/get/open-insurance/products-services/v2/engineering"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Engineering (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/engineering.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/engineering",
        "summary": "List engineering open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Environmental Liability",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/environmental-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/environmental-liability",
        "summary": "List environmental-liability open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.environmental-liability",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataenvironmental-liability/get/open-insurance/products-services/v2/environmental-liability"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Environmental Liability (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/environmental-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/environmental-liability",
        "summary": "List environmental-liability open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Equipment Breakdown",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/equipment-breakdown.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/equipment-breakdown",
        "summary": "List equipment-breakdown open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.equipment-breakdown",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataequipment-breakdown/get/open-insurance/products-services/v2/equipment-breakdown"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Equipment Breakdown (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/equipment-breakdown.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/equipment-breakdown",
        "summary": "List equipment-breakdown open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Errors & Omissions Liability",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/errors-omissions-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/errors-omissions-liability",
        "summary": "List errors-omissions-liability open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.errors-omissions-liability",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataerrors-omissions-liability/get/open-insurance/products-services/v2/errors-omissions-liability"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Errors & Omissions Liability (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/errors-omissions-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/errors-omissions-liability",
        "summary": "List errors-omissions-liability open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Export Credit",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/export-credit.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/export-credit",
        "summary": "List export-credit open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.export-credit",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataexport-credit/get/open-insurance/products-services/v2/export-credit"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Export Credit (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/export-credit.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/export-credit",
        "summary": "List export-credit open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Extended Warranty",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/extended-warranty.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/extended-warranty",
        "summary": "List extended-warranty open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.extended-warranty",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataextended-warranty/get/open-insurance/products-services/v2/extended-warranty"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Extended Warranty (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/extended-warranty.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/extended-warranty",
        "summary": "List extended-warranty open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Financial Risk",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/financial-risk.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/financial-risk",
        "summary": "List financial-risk open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.financial-risk",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datafinancial-risk/get/open-insurance/products-services/v2/financial-risk"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Financial Risk (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/financial-risk.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/financial-risk",
        "summary": "List financial-risk open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — General Liability",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/general-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/general-liability",
        "summary": "List general-liability open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.general-liability",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datageneral-liability/get/open-insurance/products-services/v2/general-liability"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — General Liability (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/general-liability.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/general-liability",
        "summary": "List general-liability open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Home Insurance",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/home-insurance.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/home-insurance/commercializationArea/{commercializationArea}",
        "summary": "List home-insurance products by commercialization area",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.home-insurance",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datahome-insurance/get/open-insurance/products-services/v2/home-insurance/commercializationArea/{commercializationArea}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Home Insurance (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/home-insurance.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/home-insurance/commercializationArea/{commercializationArea}",
        "summary": "List home-insurance products by commercialization area",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Housing",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/housing.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/housing",
        "summary": "List housing open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.housing",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datahousing/get/open-insurance/products-services/v2/housing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Housing (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/housing.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/housing",
        "summary": "List housing open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Life Pension",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/life-pension.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/life-pension",
        "summary": "List life-pension open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.life-pension",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datalife-pension/get/open-insurance/products-services/v2/life-pension"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Life Pension (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/life-pension.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/life-pension",
        "summary": "List life-pension open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Lost Profit",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/lost-profit.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/lost-profit",
        "summary": "List lost-profit open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.lost-profit",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datalost-profit/get/open-insurance/products-services/v2/lost-profit"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Lost Profit (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/lost-profit.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/lost-profit",
        "summary": "List lost-profit open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Pension Plan",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/pension-plan.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/pension-plan",
        "summary": "List pension-plan open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.pension-plan",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datapension-plan/get/open-insurance/products-services/v2/pension-plan"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Pension Plan (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/pension-plan.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/pension-plan",
        "summary": "List pension-plan open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Person",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/person.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/person",
        "summary": "List person open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.person",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataperson/get/open-insurance/products-services/v2/person"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Person (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/person.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/person",
        "summary": "List person open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Private Guarantee",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/private-guarantee.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/private-guarantee",
        "summary": "List private-guarantee open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.private-guarantee",
        "scalarPath": "/reference/insurance#tag/insuranceopen-dataprivate-guarantee/get/open-insurance/products-services/v2/private-guarantee"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Private Guarantee (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/private-guarantee.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/private-guarantee",
        "summary": "List private-guarantee open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Public Guarantee",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/public-guarantee.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/public-guarantee",
        "summary": "List public-guarantee open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.public-guarantee",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datapublic-guarantee/get/open-insurance/products-services/v2/public-guarantee"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Public Guarantee (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/public-guarantee.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/public-guarantee",
        "summary": "List public-guarantee open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Rent Guarantee",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/rent-guarantee.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/rent-guarantee",
        "summary": "List rent-guarantee open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.rent-guarantee",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datarent-guarantee/get/open-insurance/products-services/v2/rent-guarantee"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Rent Guarantee (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/rent-guarantee.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/rent-guarantee",
        "summary": "List rent-guarantee open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Rural",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/rural.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/rural",
        "summary": "List rural open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.rural",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datarural/get/open-insurance/products-services/v2/rural"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Rural (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/rural.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/rural",
        "summary": "List rural open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Stop Loss",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/stop-loss.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/stop-loss",
        "summary": "List stop-loss open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.stop-loss",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datastop-loss/get/open-insurance/products-services/v2/stop-loss"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Stop Loss (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/stop-loss.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/stop-loss",
        "summary": "List stop-loss open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Transport",
    "phase": "1",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/transport.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/transport",
        "summary": "List transport open data",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.open-data.transport",
        "scalarPath": "/reference/insurance#tag/insuranceopen-datatransport/get/open-insurance/products-services/v2/transport"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Open Data — Transport (v3)",
    "phase": "1",
    "regulatoryVersion": "v3.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/transport.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/transport",
        "summary": "List transport open data",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Endorsement",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/endorsement/v2/request/{consentId}",
        "summary": "Submit endorsement request for an active consent",
        "requiredScopes": ["endorsement"],
        "status": "implemented",
        "implementedTag": "insurance.holder.commands",
        "scalarPath": "/reference/insurance#tag/insuranceholdercommands/post/open-insurance/endorsement/v2/request/{consentId}"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Notifications",
    "phase": "3",
    "regulatoryVersion": "v1.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/notifications/v1/quote-notification",
        "summary": "Publish quote acceptance/rejection notification",
        "requiredScopes": ["notifications"],
        "status": "implemented",
        "implementedTag": "insurance.holder.commands",
        "scalarPath": "/reference/insurance#tag/insuranceholdercommands/post/open-insurance/notifications/v1/quote-notification"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Patrimonial",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "expectedOperations": 14,
    "implementedOperations": 0,
    "missingOperations": 14,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/lead/request",
        "summary": "Create patrimonial lead",
        "requiredScopes": ["quote-patrimonial-lead"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/lead/request/{consentId}",
        "summary": "Revoke patrimonial lead",
        "requiredScopes": ["quote-patrimonial-lead"],
        "status": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/home/request",
        "summary": "Create patrimonial home quote",
        "requiredScopes": ["quote-patrimonial-home"],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/home/request/{consentId}/quote-status",
        "summary": "Read patrimonial home quote status",
        "requiredScopes": ["quote-patrimonial-home"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/home/request/{consentId}",
        "summary": "Cancel patrimonial home quote",
        "requiredScopes": ["quote-patrimonial-home"],
        "status": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/condominium/request",
        "summary": "Create patrimonial condominium quote",
        "requiredScopes": ["quote-patrimonial-condominium"],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/condominium/request/{consentId}/quote-status",
        "summary": "Read patrimonial condominium quote status",
        "requiredScopes": ["quote-patrimonial-condominium"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/condominium/request/{consentId}",
        "summary": "Cancel patrimonial condominium quote",
        "requiredScopes": ["quote-patrimonial-condominium"],
        "status": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/business/request",
        "summary": "Create patrimonial business quote",
        "requiredScopes": ["quote-patrimonial-business"],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/business/request/{consentId}/quote-status",
        "summary": "Read patrimonial business quote status",
        "requiredScopes": ["quote-patrimonial-business"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/business/request/{consentId}",
        "summary": "Cancel patrimonial business quote",
        "requiredScopes": ["quote-patrimonial-business"],
        "status": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/diverse-risks/request",
        "summary": "Create patrimonial diverse-risks quote",
        "requiredScopes": ["quote-patrimonial-diverse-risks"],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/diverse-risks/request/{consentId}/quote-status",
        "summary": "Read patrimonial diverse-risks quote status",
        "requiredScopes": ["quote-patrimonial-diverse-risks"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/diverse-risks/request/{consentId}",
        "summary": "Cancel patrimonial diverse-risks quote",
        "requiredScopes": ["quote-patrimonial-diverse-risks"],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Responsibility",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "expectedOperations": 2,
    "implementedOperations": 0,
    "missingOperations": 2,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-responsibility/v2/lead/request",
        "summary": "Create quote-responsibility lead",
        "requiredScopes": ["quote-responsibility-lead"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-responsibility/v2/lead/request/{consentId}",
        "summary": "Revoke quote-responsibility lead",
        "requiredScopes": ["quote-responsibility-lead"],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Financial Risk",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "expectedOperations": 2,
    "implementedOperations": 0,
    "missingOperations": 2,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-financial-risk/v2/lead/request",
        "summary": "Create quote-financial-risk lead",
        "requiredScopes": ["quote-financial-risk-lead"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-financial-risk/v2/lead/request/{consentId}",
        "summary": "Revoke quote-financial-risk lead",
        "requiredScopes": ["quote-financial-risk-lead"],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Quote Acceptance And Branches Abroad",
    "phase": "3",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://opinbrasil.atlassian.net/wiki/spaces/RDD/pages/30605384",
    "expectedOperations": 2,
    "implementedOperations": 0,
    "missingOperations": 2,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-acceptance-and-branches-abroad/v2/lead/request",
        "summary": "Create acceptance-and-branches-abroad lead",
        "requiredScopes": ["quote-acceptance-and-branches-abroad-lead"],
        "status": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-acceptance-and-branches-abroad/v2/lead/request/{consentId}",
        "summary": "Revoke acceptance-and-branches-abroad lead",
        "requiredScopes": ["quote-acceptance-and-branches-abroad-lead"],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Comuns (Status & Outages)",
    "phase": "cross-cutting",
    "regulatoryVersion": "v1.3.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/discovery.yaml",
    "expectedOperations": 2,
    "implementedOperations": 2,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/discovery/v1/status",
        "summary": "List API status",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.holder.discovery",
        "scalarPath": "/reference/insurance#tag/insuranceholderdiscovery/get/open-insurance/discovery/v1/status"
      },
      {
        "method": "get",
        "path": "/open-insurance/discovery/v1/outages",
        "summary": "List scheduled service outages",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.holder.discovery",
        "scalarPath": "/reference/insurance#tag/insuranceholderdiscovery/get/open-insurance/discovery/v1/outages"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Comuns (Status & Outages) (v2)",
    "phase": "cross-cutting",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/discovery.yaml",
    "expectedOperations": 2,
    "implementedOperations": 0,
    "missingOperations": 2,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/discovery/v2/status",
        "summary": "List API status",
        "requiredScopes": [],
        "status": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/discovery/v2/outages",
        "summary": "List scheduled service outages",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Admin (Metrics)",
    "phase": "cross-cutting",
    "regulatoryVersion": "v1.3.0",
    "lifecycle": "deprecated",
    "targetProfile": "deprecated",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/8fdc368d0965ec20b1f70c48ba7f16921842da58/documentation/source/files/swagger/current/admin_metrics.yaml",
    "expectedOperations": 1,
    "implementedOperations": 1,
    "missingOperations": 0,
    "extraOperations": 0,
    "coveragePercent": 100,
    "status": "implemented",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/admin/v1/metrics",
        "summary": "Read API availability metrics",
        "requiredScopes": [],
        "status": "implemented",
        "implementedTag": "insurance.holder.admin",
        "scalarPath": "/reference/insurance#tag/insuranceholderadmin/get/open-insurance/admin/v1/metrics"
      }
    ]
  },
  {
    "coverageBasis": "method-path-presence",
    "family": "Admin (Metrics) (v2)",
    "phase": "cross-cutting",
    "regulatoryVersion": "v2.0.0",
    "lifecycle": "current",
    "targetProfile": "current",
    "sourceUrl": "https://raw.githubusercontent.com/br-openinsurance/areadesenvolvedor/053f01f6a830f674e71ffcf60f899b1a417d99d6/documentation/source/files/swagger/current/admin_metrics.yaml",
    "expectedOperations": 1,
    "implementedOperations": 0,
    "missingOperations": 1,
    "extraOperations": 0,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/admin/v2/metrics",
        "summary": "Read API availability metrics",
        "requiredScopes": [],
        "status": "missing"
      }
    ]
  }
]
